
import { Component, OnInit, Input, ElementRef, ViewChild } from '@angular/core';
import { FlexLayoutModule } from '@angular/flex-layout';

@Component({
    selector: 'topo-avatar',
    templateUrl: './avatar.component.html',
    styleUrls: ['./avatar.component.scss'],
    imports: [FlexLayoutModule]
})
export class AvatarComponent implements OnInit {
  @Input()
  set name(value: string) {
    if (this._name !== value) {
      this.initials = null;
    }
    this._name = value;
    this.textValue = this.initials ?? this.calculateInitials();
    this.calculateBackgroundColor();
  }
  get name() {
    return this._name;
  }
  _name: string;
  @Input() size: number;
  @Input() fontSize = 12;
  @Input() userProfileUId: string;
  @Input() organizationUId: string;
  @Input() initials: string;
  @Input() backgroundColor: string;
  @Input() showName = false;
  backgroundImageUrl: string;
  public textValue: string;
  _imageUrl: string;
  @Input() set imageUrl(imageUrl: string) {
    this._imageUrl = imageUrl;

    this.backgroundImageUrl = imageUrl ? `url("${this.imageUrl}")` : null;
  }

  get imageUrl() {
    return this._imageUrl;
  }

  imageLoaded: boolean;

  colors = ['#4782B6', '#FBE7E8', '#FFBA08', '#3A8E06', '#EE6400', '#6747E9'];

  constructor() {}

  ngOnInit(): void {
    this.imageLoaded = false;

    if (!!this.organizationUId && !!this.userProfileUId) {
      this.imageUrl = `api/v1/iam/organizations/${this.organizationUId}/user-profiles/${this.userProfileUId}/avatar`;
    }

    this.initials = this.initials ?? this.calculateInitials();
    this.textValue = this.initials;
    this.backgroundColor = this.backgroundColor ?? this.calculateBackgroundColor();
  }

  calculateInitials(): string {
    let value = 'AA';

    if (!!this.name?.trim()) {
      // replace doubled up spaces in middle of name value as .trim() only removes trailing whitespace
      const segments = this.name.replace(/\s+/g, ' ').trim().split(' ');
      if (segments.length > 1) {
        value = `${segments[0][0]}${segments[1][0]}`;
      } else {
        value = this.name.length > 1 ? this.name.substring(0, 2) : this.name;
      }
    }

    value = value.toLocaleUpperCase();

    return value;
  }

  onImageLoaded(done: any): void {
    if (this.imageUrl === null) {
      return;
    }
    this.imageLoaded = done;
  }

  calculateBackgroundColor(): string {
    if (this.initials) {
      const code = this.initials.charCodeAt(0);
      const index = code % 6;

      return this.colors[index];
    }

    return this.colors[0];
  }
}
